
import { apiRequest } from '../../apiCall'
import { HolyDayType } from '../../types/CalendarHolidy/apiRequestTypes'
import { GetListPublicParamsType } from '../../types/common/commonTypes'


export const addHolidayRequest = (params: HolyDayType) => apiRequest('Calendar.add', params, '', true)
export const updateHolidayRequest = (params: HolyDayType) => apiRequest('Calendar.update', params, '', true)
export const getHolidayRequest = (params: GetListPublicParamsType) => apiRequest('Calendar.get', params, '', true)
export const deleteHolidayRequest = (params: GetListPublicParamsType) => apiRequest('Calendar.get', params, '', true)


